import React, { useEffect, useState, useCallback } from "react";
import { AlertTriangle, Info, Wrench, Moon } from "lucide-react";
import { api } from "../lib/api";

const STYLES = {
  info: { bar: "bg-sky-950/70 border-sky-500/40 text-sky-100", Icon: Info, iconc: "text-sky-400" },
  warning: { bar: "bg-amber-950/60 border-amber-500/40 text-amber-100", Icon: AlertTriangle, iconc: "text-amber-400" },
  maintenance: { bar: "bg-red-950/70 border-red-500/50 text-red-100", Icon: Wrench, iconc: "text-red-400" },
};

export function useSiteStatus() {
  const [status, setStatus] = useState(null);
  const load = useCallback(() => {
    api.get("/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("ps-status-refresh", load);
    return () => { clearInterval(t); window.removeEventListener("ps-status-refresh", load); };
  }, [load]);
  return status;
}

export function StatusBanner({ status }) {
  if (!status || !status.active || !status.message) return null;
  const s = STYLES[status.level] || STYLES.info;
  const { Icon } = s;
  return (
    <div data-testid="site-status-banner" className={`rounded-xl border px-4 py-2.5 mb-4 flex items-center gap-2.5 text-sm ${s.bar}`}>
      <Icon className={`w-4 h-4 shrink-0 ${s.iconc}`} />
      <span className="flex-1 min-w-0" data-testid="site-status-message">{status.message}</span>
    </div>
  );
}

export function MaintenanceLock({ status, onLogout }) {
  return (
    <div data-testid="maintenance-lock" className="min-h-screen sanctuary-bg flex items-center justify-center p-6">
      <div className="glass border border-red-500/30 rounded-2xl max-w-md w-full p-8 text-center animate-slide-up">
        <Moon className="w-14 h-14 text-red-400 mx-auto mb-4" />
        <h1 className="font-display text-2xl text-slate-100">The Sanctuary is Resting</h1>
        <p className="text-slate-400 text-sm mt-3" data-testid="maintenance-message">
          {status?.message || "The pack is performing maintenance. We'll be howling again shortly."}
        </p>
        <button onClick={onLogout} data-testid="maintenance-logout" className="mt-6 inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-700 text-slate-200 text-sm font-medium px-5 py-2 rounded-full transition-colors">
          Log out
        </button>
      </div>
    </div>
  );
}
